import React from 'react';

export default function EntityCardGrid({ children, emptyState = null }) {
  if (!children || (Array.isArray(children) && children.length === 0)) {
    return emptyState ? <div className="wt-entity-grid__empty">{emptyState}</div> : null;
  }

  return <section className="wt-entity-grid">{children}</section>;
}
